
import { Game } from "@/models/Game";
import { GoalsList } from "@/models/MapPois/Quest/Goals";
import { Component, Vue, Prop } from "vue-property-decorator";
import ActionInventoryExit from "./ActionInventoryExit.vue";
import ActionPoiExit from "./ActionPoiExit.vue";
import ActionQuestStatusExit from "./ActionQuestStatusExit.vue";
import ActionPlayTimerExit from "./ActionPlayTimerExit.vue";

@Component({
  components: {
    ActionInventoryExit,
    ActionPoiExit,
    ActionQuestStatusExit,
    ActionPlayTimerExit,
  },
})
class ActionBoxTabExit extends Vue {
  @Prop({ default: null }) readonly title!: string;
  @Prop({ default: null }) readonly objectName!: string;
  @Prop({ default: false }) readonly contentData!: GoalsList;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: "" }) readonly mapPoiKey!: string;
  @Prop({ default: null }) readonly gameData!: Game;

  active = false;
  inventoryGoal = false;
  questStatus = false;
  poiStatus = false;
  playTimer = false;

  get getActive(): boolean {
    if (
      this.getContentData !== undefined &&
      Object.keys(this.getContentData).includes(this.objectName)
    ) {
      return true;
    } else {
      return false;
    }
  }

  get getContentData(): GoalsList {
    if (this.contentData == false) {
      return {} as GoalsList;
    }
    return this.contentData;
  }

  openEditTabs(): void {
    if (this.objectName === "invGoal") {
      this.inventoryGoal = true;
    }
    if (this.objectName === "questStatusGoal") {
      this.questStatus = true;
    }
    if (this.objectName === "poiStatusGoal") {
      this.poiStatus = true;
    }
    if (this.objectName === "playTimerGoal") {
      this.playTimer = true;
    }
  }
  cancel(): void {
    this.inventoryGoal = false;
    this.questStatus = false;
    this.poiStatus = false;
    this.playTimer = false;
  }

  update(contentData: any): void {
    try {
      if (this.objectName === "poiStatusGoal") {
        this.getContentData.poiStatusGoal = contentData;
      }
      if (this.objectName === "invGoal") {
        this.getContentData.invGoal = contentData;
      }
      if (this.objectName === "questStatusGoal") {
        this.getContentData.questStatusGoal = contentData;
      }
      if (this.objectName === "playTimerGoal") {
        this.getContentData.playTimerGoal = contentData;
      }
      var data = {
        contentData: this.getContentData,
        actionDetails: contentData,
        objectName: this.objectName,
      };
      this.cancel();
      this.$emit("update", data);
    } catch (error) {
      console.log(error);
    }
  }

  deleteAction(): void {
    if (this.objectName === "poiStatusGoal") {
      delete this.getContentData.poiStatusGoal;
    }
    if (this.objectName === "invGoal") {
      delete this.getContentData.invGoal;
    }
    if (this.objectName === "questStatusGoal") {
      delete this.getContentData.questStatusGoal;
    }
    if (this.objectName === "playTimerGoal") {
      delete this.getContentData.playTimerGoal;
    }
    var data = {
      contentData: this.getContentData,
      objectName: this.objectName,
    };
    this.cancel();
    this.$emit("deleteAction", data);
  }
}

export default ActionBoxTabExit;
